import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PieChart03 = function PieChart03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2a10 10 0 0 1 9.2388 6.1732A10 10 0 0 1 22 12M12 2v10m0-10C6.4772 2 2 6.4772 2 12s4.4772 10 10 10 10-4.4771 10-10M12 2c5.5228 0 10 4.4772 10 10m0 0H12m10 0a10 10 0 0 1-4.1221 8.0902L12 12"
    })
  }));
};
export default PieChart03;